<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-11 09:48:44
 * @LastEditors: xiaobai
 * @LastEditTime: 2021-06-11 10:52:30
 * @FilePath: /fujian/src/views/about_us/components/development_history.vue
-->
<template>
  <div>
    <div class="mt-10 development_historys">
      <div class="development_history_a" v-for="(item,index) in historyList" :key="index">
        <div class="left_box">
          <span class="left_text">{{item.year}}</span>
        </div>
        <div class="right_box">
          <div class="right_text" v-html="item.content">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data(){
    return{
      historyList:[]
    }
  },
  mounted(){
    this.getHistoryList()
  },
  methods:{
    getHistoryList(){
      axios.post('/home/development/path', {}).then((res) => {
        this.historyList = res.data.data.developmentPathList
      })
    },
  }
}
</script>

<style>

</style>